import React, { useEffect } from "react";
import { Footer } from "./components/Footer/Footer";
import { Header } from "./components/Header/Header";
import VehiculosProvider from "./context/VehiculosContext";
import ReactGA from "react-ga4";
import "./assets/scss/styles.scss";
import WhatsAppFlotante from "./components/WhatsAppFlotante/WhatsAppFlotante";

export const App = () => {
  useEffect(() => {
    ReactGA.initialize([
      {
        trackingId: "G-469B6797TE",
      },
    ]);
  }, []);

  return (
    <VehiculosProvider>
      <Header />
      <Footer />
      <WhatsAppFlotante />
    </VehiculosProvider>
  );
};
